import {
    SalesItems,
} from "tilby-models";

/**
 * Builds the product reference sent to PMS services for a sale item.
 *
 * - Catalog items: `productId` is the item id, `productCode` is the SKU (or `SCL<item_id>` when missing).
 * - Department-only items (no item id): both fields fall back to `SCLD<department_id>`, so they can't
 *   collide with the `SCL<item_id>` codes generated for catalog items.
 */
export function getPmsProductRef(item: Pick<SalesItems, 'sku' | 'item_id' | 'department_id'>): { productCode: string, productId: string } {
    if (item.item_id) {
        return {
            productCode: item.sku || `SCL${item.item_id}`,
            productId: item.item_id.toString()
        };
    }

    const departmentRef = `SCLD${item.department_id}`;

    return {
        productCode: item.sku || departmentRef,
        productId: departmentRef
    };
}
